"use client";

import { useEffect, useMemo, useState } from "react";
import {
  getContactEmail,
  getHeaderLogoSource,
  getHomeLogoSource,
  isJinnyApp,
  isMemoringApp,
} from "./appConfig";
import { type Configuration, getAppConfiguration } from "./configuration";

const emptyConfiguration: Configuration = {
  appName: "",
  basePath: "",
  apiUrl: "",
  providerId: "",
  mapBoxToken: "",
  mapBoxUrl: "",
  recaptchaSiteKey: "",
  recaptchaSecretKey: "",
  apiWebSocketUrl: "",
  mediaBuilderApiUrl: "",
  mediaBuilderApiWebSocketUrl: "",
  landingUrl: "",
  mode: "development",
  adminPanelPath: "",
  googleRecaptchaSiteKey: "",
  googleTagManagerId: "",
  googleAnalyticsMeasurementId: "",
  ipApiUrl: "",
};

export function useAppConfiguration() {
  const [appConfiguration, setAppConfiguration] =
    useState<Configuration>(emptyConfiguration);

  useEffect(() => {
    getAppConfiguration().then((config) => {
      setAppConfiguration(config);
    });
  }, []);

  const isJinny = useMemo(() => {
    return isJinnyApp(appConfiguration);
  }, [appConfiguration]);

  const isMemoring = useMemo(() => {
    return isMemoringApp(appConfiguration);
  }, [appConfiguration]);

  const contactEmail = useMemo(() => {
    return getContactEmail(appConfiguration);
  }, [appConfiguration]);

  const homeLogoSource = useMemo(
    () => getHomeLogoSource(appConfiguration),
    [appConfiguration]
  );

  const headerLogoSource = useMemo(
    () => getHeaderLogoSource(appConfiguration),
    [appConfiguration]
  );

  return useMemo(() => {
    return {
      ...appConfiguration,
      isMemoringApp: isMemoring,
      isJinnyApp: isJinny,
      contactEmail,
      homeLogoSource,
      headerLogoSource,
    };
  }, [
    appConfiguration,
    contactEmail,
    homeLogoSource,
    headerLogoSource,
    isJinny,
    isMemoring,
  ]);
}
